// extracted by mini-css-extract-plugin
export var chevron = "_ik-2";
export var dropdownItems = "_ik-0";
export var item = "_ik-1";